import { DescriptionOutlinedIcon, NoRowsOverlay } from '@shared/components';

interface EmptyExamLocationRequestsOverlayProps {
  title: string;
}

export default function EmptyExamLocationRequestsOverlay(
  props: EmptyExamLocationRequestsOverlayProps,
) {
  const { title } = props;

  return <NoRowsOverlay title={title} icon={DescriptionOutlinedIcon} />;
}
